<ng-container *ngIf="canDelete">
  <crm-task-edit-form
    [isModal]="isModal"
    [task]="task"
    [canDelete]="true"
    [permissions]="permissions"
    route="/payments/task/card/{{ brsPrefixService.addPrefixToNumber(task['number']) }}"
    [organizations]="organizations"
    [filials]="filials"
    [units]="units"
    [priorities]="priorities"
    [directions]="directions"
    [nds]="nds"
    [banks]="banks"
    [statuses]="statuses"
    [schemes]="schemes"
    [currencies]="currencies"
    [bankDetails]="bankDetails"
    [contragentBankDetails]="contragentBankDetails"
    (changeContragent)="changeContragent.emit($event)"
    (changeOrganization)="changeOrganization.emit($event)"
    (reloadOrganizationBankDetails)="reloadOrganizationBankDetails.emit()"
    (bankSearch)="bankSearch.emit($event)"
    (save)="save.emit($event)"
    (delete)="delete.emit($event)"></crm-task-edit-form>
</ng-container>
<ng-container *ngIf="!canDelete">
  <p-steps
    [model]="steps"
    [activeIndex]="activeStep"></p-steps>

  <div class="grid mt-3">
    <ng-container *ngIf="activeStep === 0">
      <div class="xl:col-4 md:col-6 col-12">
        <p-card styleClass="very-compact-card p-3">
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium">Тип заявки</label>
              <crm-single-select
                [options]="kinds"
                [(selectedItem)]="task.kind"
                optionValue="name"
                class="w-full {{ errors?.kind ? 'ng-invalid ng-dirty' : '' }}"
                [styleClass]="errors?.kind ? 'ng-invalid ng-dirty' : ''"
                [isTemplateCombined]="true"
                [filter]="false"
                [showClear]="true"
                [loading]="kindLoading"
                (selectedItemChange)="changeKind()"
                appendTo="body">
                <ng-template
                  #itemTemplate
                  let-kind="item">
                  {{ kind.value | taskKindName }}
                </ng-template>
              </crm-single-select>
              <small
                *ngIf="errors?.kind"
                class="p-error">
                {{ errors.kind | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium required-field">Статус</label>
              <crm-single-select
                [options]="statuses | sortTaskStatusByOrder"
                [(selectedItem)]="task.status"
                (selectedItemChange)="selectedStatus()"
                sort="order:number"
                [filter]="false"
                [disabled]="kindLoading"
                [styleClass]="errors?.status ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.status ? 'ng-invalid ng-dirty' : ''"
                appendTo="body"></crm-single-select>
              <small
                *ngIf="errors?.status"
                class="p-error">
                {{ errors.status | join }}
              </small>
            </div>
          </div>

          <div class="mt-3 flex justify-content-end">
            <crm-go-back-button
              *ngIf="!isModal"
              [route]="route"></crm-go-back-button>
          </div>
        </p-card>
      </div>
    </ng-container>

    <ng-container *ngIf="activeStep === 1">
      <div class="lg:col-6 col-12">
        <p-card styleClass="very-compact-card p-3 mb-3">
          <h3 class="m-0">Счет</h3>

          <div class="mt-3">
            <div
              class="flex flex-wrap mb-2"
              *ngIf="task.files?.length">
              <div
                *ngFor="let file of task.files"
                class="p-2">
                <crm-file
                  [file]="file"
                  [canDelete]="true"
                  (delete)="deleteFile(task.files, file)">
                </crm-file>
              </div>
            </div>
            <p-fileUpload
              *ngIf="!task.files?.length"
              #fileUpload
              mode="basic"
              [customUpload]="true"
              chooseIcon="pi-paperclip"
              chooseLabel="Прикрепить файл"
              [disabled]="uploadingFiles || isInvoiceParsing"
              (uploadHandler)="uploadFiles($event)"
              [auto]="true">
            </p-fileUpload>

            <div
              *ngIf="isInvoiceParsing"
              class="flex align-items-center gap-2 mt-2">
              <p-progressSpinner
                styleClass="w-2rem h-2rem"
                strokeWidth="4">
              </p-progressSpinner>
              <span>Анализ счета...</span>
            </div>
          </div>
        </p-card>

        <p-card
          header="Контрагент"
          styleClass="mt-3">
          <div class="formgrid grid">
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">Контрагент</label>
              <crm-contragent-auto-complete
                [(selectedContragent)]="task.contragent"
                (selectedContragentChange)="changeContragent.emit($event)"
                [customSearch]="false"
                appendTo="body"></crm-contragent-auto-complete>
            </div>

            <div
              *ngIf="task.contragent"
              class="field lg:col-6 col-12">
              <label class="font-medium required-field">Расчетный счет Контрагента</label>

              <div class="flex align-items-center justify-content-between">
                <crm-bank-details-single-select
                  class="flex-grow-1 mr-1"
                  [bankDetails]="contragentBankDetails"
                  [(selectedBankDetail)]="task.contragentBankDetails"
                  [isError]="$any(errors?.contragentBankDetails)"
                  [customRequest]="true"
                  appendTo="body"></crm-bank-details-single-select>
                <crm-button
                  icon="pi pi-plus"
                  pTooltip="Добавить счета"
                  tooltipPosition="top"
                  styleClass="p-button-success-create"
                  (onClick)="onContragentBankDetailsAddClick()"></crm-button>
              </div>

              <small
                *ngIf="errors?.contragentBankDetails"
                class="p-error">
                {{ errors.contragentBankDetails | join }}
              </small>
            </div>
          </div>
        </p-card>

        <p-card
          header="Плательщик"
          styleClass="mt-3">
          <div class="formgrid grid">
            <div
              *ngIf="task.status?.formSettings?.organization?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.organization?.required"
                >Плательщик</label
              >
              <crm-company-single-select
                [companies]="organizations"
                [(selectedCompany)]="task.organization"
                [customRequest]="true"
                [disabled]="!permissions.organization"
                (selectedCompanyChange)="changeOrganization.emit($event)"
                [styleClass]="errors?.organization ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.organization ? 'ng-invalid ng-dirty' : ''">
              </crm-company-single-select>
              <small
                *ngIf="errors?.organization"
                class="p-error"
                >{{ errors.organization | join }}</small
              >
            </div>

            <div
              *ngIf="task.status?.formSettings?.organizationBankDetails?.visible && task.organization"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.organizationBankDetails?.required"
                >Расчетный счет Плательщика</label
              >
              <crm-bank-details-single-select
                [bankDetails]="bankDetails"
                [(selectedBankDetail)]="task.organizationBankDetails"
                [companyIds]="task.organization ? [task.organization.id] : []"
                [disabled]="!permissions.organizationBankDetails"
                [isError]="$any(errors?.organizationBankDetails)"
                [customRequest]="true"
                (reloadBankDetails)="reloadOrganizationBankDetails.emit()"
                appendTo="body"></crm-bank-details-single-select>
              <small
                *ngIf="errors?.organizationBankDetails"
                class="p-error">
                {{ errors.organizationBankDetails | join }}
              </small>
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Договор</label>
              <crm-contract-single-select
                [(selectedEntity)]="task.contract"
                [companyIds]="task.organization ? [task.organization.id] : []"
                [contragentIds]="task.contragent ? [task.contragent.id] : []"
                [showClear]="true"
                appendTo="body">
              </crm-contract-single-select>
            </div>

            <div
              *ngIf="task.status?.formSettings?.filial?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.filial?.required">
                Филиал
              </label>
              <crm-filial-single-select
                [showClear]="true"
                [filials]="filials"
                [(selectedFilial)]="task.filial"
                [isError]="$any(errors?.filial)"
                [disabled]="!permissions.filial"
                [customRequest]="true"></crm-filial-single-select>
              <small
                *ngIf="errors?.filial"
                class="p-error">
                {{ errors.filial | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.unit?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.unit?.required">
                Бизнес единица
              </label>
              <crm-unit-single-select
                [units]="units"
                [disabled]="!permissions.unit"
                [(selectedUnit)]="task.unit"
                [isError]="$any(errors?.unit)"
                [customRequest]="true"
                [showClear]="true">
              </crm-unit-single-select>
              <small
                *ngIf="errors?.unit"
                class="p-error">
                {{ errors.unit | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.direction?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.direction?.required"
                >Бюджетная статья</label
              >
              <crm-direction-single-select
                [directions]="directions"
                [disabled]="!permissions.direction"
                [(selectedDirection)]="task.direction"
                [groupsDisabled]="true"
                [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''">
              </crm-direction-single-select>
              <small
                *ngIf="errors?.direction"
                class="p-error"
                >{{ errors.direction | join }}</small
              >
            </div>
          </div>
        </p-card>

        <p-card
          header="Детали платежа"
          styleClass="mt-3">
          <div class="formgrid grid">
            <div
              *ngIf="task.status?.formSettings?.subject?.visible"
              class="field col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.subject?.required"
                >Назначение</label
              >
              <crm-input-text
                [(value)]="task.subject"
                class="w-full"
                [disabled]="!permissions.subject"
                [isError]="$any(errors?.subject) || task.subject?.length > 190"></crm-input-text>
              <small
                *ngIf="errors?.subject"
                class="p-error"
                >{{ errors.subject | join }}</small
              >
              <small
                *ngIf="task.subject?.length > 190"
                class="p-error">
                Назначение платежа не должно превышать 190 символов.
              </small>
            </div>

            @if ([TaskKindEnum.PAYMENT_TO_SELF_EMPLOYED, TaskKindEnum.PAYMENT_TO_SUPPLIER].includes(task.kind)) {
              <div class="field lg:col-6 col-12">
                <label class="font-medium">Идентификатор платежа</label>
                <crm-input-text
                  [(value)]="task.paymentId"
                  class="w-full"
                  [disabled]="!permissions.paymentId"
                  [isError]="$any(errors?.paymentId)"></crm-input-text>
                <small
                  *ngIf="errors?.paymentId"
                  class="p-error">
                  {{ errors.paymentId | join }}
                </small>
              </div>
            }

            <div
              *ngIf="task.status?.formSettings?.type?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.type?.required">
                Тип платежа
              </label>
              <crm-single-select
                [options]="types"
                [(selectedItem)]="task.type"
                [disabled]="!permissions.type || task.kind === TaskKindEnum.PAYMENT_OF_SALARY"
                [isTemplateCombined]="true"
                [filter]="false"
                optionValue="name"
                [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.type ? 'ng-invalid ng-dirty' : ''">
                <ng-template
                  #itemTemplate
                  let-type="item">
                  {{ type.value | paymentType }}
                </ng-template>
              </crm-single-select>
              <small
                *ngIf="errors?.type"
                class="p-error"
                >{{ errors.type | join }}</small
              >
            </div>

            <div
              *ngIf="task.status?.formSettings?.date?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.date?.required"
                >Дата оплаты</label
              >
              <crm-datepicker
                [(value)]="task.date"
                [disabled]="!permissions.date"
                [class]="errors?.date ? 'ng-invalid ng-dirty' : ''"
                styleClass="w-full {{ errors?.date ? 'ng-invalid ng-dirty' : '' }}"></crm-datepicker>
              <small
                *ngIf="errors?.date"
                class="p-error"
                >{{ errors.date | join }}</small
              >
            </div>

            <div
              *ngIf="task.status?.formSettings?.amount?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.amount?.required"
                >Сумма</label
              >
              <p-inputNumber
                [(ngModel)]="task.amount"
                [disabled]="!permissions.amount"
                [inputStyle]="{ width: '100%' }"
                [class]="errors?.amount ? 'ng-invalid ng-dirty' : ''"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                (onBlur)="changeValue()"
                (onInput)="changeAmount($event.value)"
                styleClass="w-full"
                class="w-full">
              </p-inputNumber>
              <div
                *ngIf="task.currency && task.currency.isoCharacter !== 'RUB' && task.amount"
                class="text-medium text-lg uppercase mt-2">
                Сумма:
                {{ task.amount | currency: task.currency.isoCharacter : 'symbol' : '1.2-2' }}
              </div>
              <div
                *ngIf="task.currency && task.currency.isoCharacter !== 'RUB' && task.amount"
                class="text-sm text-gray-500 mt-1">
                {{ (task.amount || 0) * (task['rate'] || 1) | currency: 'RUB' : 'symbol' : '1.2-2' }}
              </div>
              <small
                *ngIf="errors?.amount"
                class="p-error"
                >{{ errors.amount | join }}</small
              >
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Валюта</label>
              <crm-currency-single-select
                *ngIf="!task.organization; else customSearch"
                [(selectedCurrency)]="task.currency"
                [disabled]="!permissions.currency"
                [showClear]="false"
                [isError]="$any(errors?.currency)"
                (selectedCurrencyChange)="task['rate'] = $event?.latestRate?.rate"
                appendTo="body"></crm-currency-single-select>
              <ng-template #customSearch>
                <crm-currency-single-select
                  [currencies]="currencies"
                  [(selectedCurrency)]="task.currency"
                  [customSearch]="true"
                  [disabled]="!permissions.currency"
                  [showClear]="false"
                  [isError]="$any(errors?.currency)"
                  (selectedCurrencyChange)="task['rate'] = $event?.latestRate?.rate"
                  appendTo="body"></crm-currency-single-select>
              </ng-template>

              <small
                *ngIf="errors?.currency"
                class="p-error">
                {{ errors.currency | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.nds?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.nds?.required"
                >НДС</label
              >
              <crm-single-select
                [options]="nds"
                [(selectedItem)]="task.nds"
                (selectedItemChange)="changeValue()"
                [disabled]="!permissions.nds"
                [filter]="false"
                [styleClass]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.nds ? 'ng-invalid ng-dirty' : ''">
              </crm-single-select>
              <small
                *ngIf="errors?.nds"
                class="p-error"
                >{{ errors.nds | join }}</small
              >
            </div>

            <div
              *ngIf="task.status?.formSettings?.vat?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.vat?.required"
                >Сумма НДС</label
              >
              <p-inputNumber
                [(ngModel)]="task.vat"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [class]="errors?.vat ? 'ng-invalid ng-dirty' : ''"
                [inputStyle]="{ width: '100%' }"
                styleClass="w-full"
                class="w-full"></p-inputNumber>
              <small
                *ngIf="errors?.vat"
                class="p-error">
                {{ errors.vat | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.priority?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.priority?.required"
                >Приоритет</label
              >
              <crm-single-select
                [options]="priorities"
                [(selectedItem)]="task.priority"
                [disabled]="!permissions.priority"
                [filter]="false"
                [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"></crm-single-select>
              <small
                *ngIf="errors?.priority"
                class="p-error"
                >{{ errors.priority | join }}</small
              >
            </div>

            <div
              *ngIf="task.status?.formSettings?.deal?.visible && canReadDeal"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.deal?.required"
                >Сделка</label
              >
              <crm-deal-auto-complete
                [(selectedDeal)]="task.deal"
                [isError]="$any(errors?.deal)"
                [disabled]="!permissions.deal"
                [showClear]="true"
                styleClass="w-full"
                inputStyleClass="w-full"
                appendTo="body"></crm-deal-auto-complete>
              <small
                *ngIf="errors?.deal"
                class="p-error">
                {{ errors.deal | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.costCenter?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.costCenter?.required">
                Центр затрат
              </label>
              <crm-cost-center-single-select
                [(selectedCostCenter)]="task.costCenter"
                [disabled]="!permissions.costCenter"
                [isError]="$any(errors?.costCenter)"
                appendTo="body"></crm-cost-center-single-select>
              <small
                *ngIf="errors?.costCenter"
                class="p-error">
                {{ errors.costCenter | join }}
              </small>
            </div>

            <div
              *ngIf="task.status?.formSettings?.commentary?.visible"
              class="field col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.commentary?.required"
                >Комментарий</label
              >
              <crm-editor
                [(value)]="task.commentary"
                height="110px"></crm-editor>
              <small
                *ngIf="errors?.commentary"
                class="p-error">
                {{ errors.commentary | join }}
              </small>
            </div>

            <div class="field-checkbox col-12 mb-0">
              <p-checkbox
                [(ngModel)]="task.creditPayment"
                [binary]="true"
                inputId="creditPayment"></p-checkbox>
              <label [for]="'creditPayment'">Оплата через кредитные средства</label>
            </div>
          </div>
        </p-card>
      </div>

      <div class="lg:col-6 col-12">
        <ng-container *ngIf="task.kind === TaskKindEnum.PAYMENT_OF_TAXES">
          <p-card
            header="Реквизиты платежа"
            styleClass="mb-3">
            <div class="formgrid grid">
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">КБК</label>
                <crm-budget-classification-code-single-select
                  [(selectedBudgetCode)]="task.budgetClassificactionCode"
                  appendTo="body"
                  [isError]="$any(errors?.budgetClassificactionCode)"></crm-budget-classification-code-single-select>
                <small
                  *ngIf="errors?.budgetClassificactionCode"
                  class="p-error"
                  >{{ errors.budgetClassificactionCode | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">Код ОКТМО</label>
                <crm-input-text
                  [(value)]="task.municipalityClassificationCode"
                  [isError]="$any(errors?.municipalityClassificationCode)"
                  class="w-full"></crm-input-text>
                <small
                  *ngIf="errors?.municipalityClassificationCode"
                  class="p-error"
                  >{{ errors.municipalityClassificationCode | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">Статус плательщика</label>
                <crm-payer-status-single-select
                  [(selectedPayerStatus)]="task.payerStatus"
                  appendTo="body"
                  [isError]="$any(errors?.payerStatus)"></crm-payer-status-single-select>
                <small
                  *ngIf="errors?.payerStatus"
                  class="p-error">
                  {{ errors.payerStatus | join }}
                </small>
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">УИН</label>
                <crm-input-text
                  [(value)]="task.uniqueAccrualIdentifier"
                  [isError]="$any(errors?.uniqueAccrualIdentifier)"
                  class="w-full"></crm-input-text>
                <small
                  *ngIf="errors?.uniqueAccrualIdentifier"
                  class="p-error"
                  >{{ errors.uniqueAccrualIdentifier | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">Основание платежа</label>
                <crm-input-text
                  [(value)]="task.paymentReason"
                  [isError]="$any(errors?.paymentReason)"
                  class="w-full"></crm-input-text>
                <small
                  *ngIf="errors?.paymentReason"
                  class="p-error"
                  >{{ errors.paymentReason | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">Налоговый период</label>
                <crm-input-text
                  [(value)]="task.taxPeriod"
                  [isError]="$any(errors?.taxPeriod)"
                  class="w-full"></crm-input-text>
                <small
                  *ngIf="errors?.taxPeriod"
                  class="p-error"
                  >{{ errors.taxPeriod | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">Номер документа</label>
                <crm-input-text
                  [(value)]="task.documentNumber"
                  [isError]="$any(errors?.documentNumber)"
                  class="w-full"></crm-input-text>
                <small
                  *ngIf="errors?.documentNumber"
                  class="p-error"
                  >{{ errors.documentNumber | join }}</small
                >
              </div>

              <div class="field lg:col-6 col-12">
                <label class="font-medium">Дата документа</label>
                <crm-datepicker
                  [(value)]="task.documentDate"
                  [class]="errors?.documentDate ? 'ng-invalid ng-dirty' : ''"
                  styleClass="w-full {{ errors?.documentDate ? 'ng-invalid ng-dirty' : '' }}"></crm-datepicker>
                <small
                  *ngIf="errors?.documentDate"
                  class="p-error"
                  >{{ errors.documentDate | join }}</small
                >
              </div>
            </div>
          </p-card>
        </ng-container>

        <p-card
          header="Согласователи"
          styleClass="mb-3">
          <div class="field">
            <label class="font-medium required-field">Схема согласования</label>
            <crm-approval-scheme-single-select
              [approvalSchemas]="schemes"
              [(selectedApprovalScheme)]="task.scheme"
              (selectedApprovalSchemeChange)="changeScheme($event)"
              [isError]="$any(errors?.scheme)"
              [disabled]="!permissions.scheme"
              [customRequest]="true"></crm-approval-scheme-single-select>
            <small
              *ngIf="errors?.scheme"
              class="p-error">
              {{ errors.scheme | join }}
            </small>
          </div>

          <ng-container *ngIf="task.scheme">
            <div *ngFor="let user of task.scheme.users; let index = index">
              <div class="flex align-items-center gap-1">
                <p>{{ index + 1 }}.</p>
                <crm-user-card-preview
                  [user]="user"
                  class="p-2"></crm-user-card-preview>
              </div>
            </div>
          </ng-container>
        </p-card>

        <p-card
          header="Участники"
          styleClass="mb-3">
          <div class="field">
            <label class="font-medium">Ответственный</label>
              <crm-user-single-select
                [(selectedUser)]="task.responsible"
              (selectedUserChange)="changeResponsibleUser($event)"
              [showClear]="true"
              [disabled]="!permissions.responsible"
              appendTo="body"></crm-user-single-select>
          </div>

          <ng-container
            *ngIf="
              task.status?.formSettings?.userAuditors?.visible || task.status?.formSettings?.userGroupAuditors?.visible
            ">
            <h3 class="font-medium -mb-2">Аудиторы</h3>
            <p-divider></p-divider>
          </ng-container>
          <div class="formgrid grid">
            <div
              *ngIf="task.status?.formSettings?.userAuditors?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.userAuditors?.required">
                Пользователи
              </label>
              <crm-user-multi-select
                [(selectedUsers)]="task.userAuditors"
                [disabled]="!permissions.userAuditors"
                [customRequest]="true"
                [isFloatLabel]="false"></crm-user-multi-select>
            </div>
            <div
              *ngIf="task.status?.formSettings?.userGroupAuditors?.visible"
              class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="task.status?.formSettings?.userGroupAuditors?.required"
                >Группы</label
              >
              <crm-user-group-multi-select
                [(selectedUserGroups)]="task.userGroupAuditors"
                [isFloatLabel]="false"
                [disabled]="!permissions.userGroupAuditors">
              </crm-user-group-multi-select>
            </div>
          </div>
        </p-card>

        <crm-payment-order-task
          *ngIf="task.status?.formSettings?.orders?.visible"
          [(orders)]="task.orders"
          [currency]="task.currency"
          [rate]="task['rate']"
          [disabled]="!permissions.orders"
          [nds]="nds"
          [minDate]="task.date"
          [styleClass]="task.status?.formSettings?.orders?.required ? 'required-field-card' : ''"
          [errors]="errors?.orders"
          class="block">
        </crm-payment-order-task>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="activeStep === 1"
    class="grid mt-3">
    <div class="xl:col-6 col-12 flex flex-wrap justify-content-between">
      <div>
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success mr-2"
          (onClick)="onSave()"></crm-button>
        <crm-button
          label="Назад"
          styleClass="p-button-secondary p-button-text"
          (onClick)="backStep()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>
